import { Element } from '../../common/html/element'

const EventCell = ({ event }) => {
  if (!event) return null

  return (
    <div className="flexColumn" style={{ rowGap: '4px' }}>
      <Element
        style={{
          fontSize: 12,
          color: '#3A414B',
          fontWeight: 600,
        }}
      >
        {event.title}
      </Element>
      <Element style={{ fontSize: 12, color: '#3A414B' }}>
        {event.subtitle}
      </Element>
    </div>
  )
}

export default EventCell
